const getApiUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://intern.vitill.com/api';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:4011/api';
};

const API_URL = getApiUrl();

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': token ? `Bearer ${token}` : ''
  };
};

// Products API
export const getProducts = async () => {
  const response = await fetch(`${API_URL}/products`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    throw new Error('Failed to fetch products');
  }
  return response.json();
};

export const createProduct = async (product: any) => {
  const response = await fetch(`${API_URL}/products`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(product)
  });
  if (!response.ok) throw new Error('Failed to create product');
  return response.json();
};

export const updateProduct = async (id: string, product: any) => {
  const response = await fetch(`${API_URL}/products/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(product)
  });
  
  if (!response.ok) {
    throw new Error('Failed to update product');
  }
  
  return response.json();
};

export const deleteProduct = async (id: string) => {
  const response = await fetch(`${API_URL}/products/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw new Error('Failed to delete product');
  return response.json();
};

// Companies API
export const getCompanies = async () => {
  const response = await fetch(`${API_URL}/companies`, {
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    throw new Error('Failed to fetch companies');
  }
  return response.json();
};

export const createCompany = async (company: any) => {
  const response = await fetch(`${API_URL}/companies`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(company)
  });
  if (!response.ok) {
    throw new Error('Failed to create company');
  }
  return response.json();
};

export const updateCompany = async (id: string, company: any) => {
  const response = await fetch(`${API_URL}/companies/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(company)
  });
  if (!response.ok) {
    throw new Error('Failed to update company');
  }
  return response.json();
};

export const deleteCompany = async (id: string) => {
  const response = await fetch(`${API_URL}/companies/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) {
    throw new Error('Failed to delete company');
  }
  return response.json();
};

export const testApiConnection = async () => {
  try {
    const response = await fetch(`${API_URL}/health`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.ok;
  } catch (error) {
    return false;
  }
};

export const getInvoices = async () => {
  const response = await fetch(`${API_URL}/invoices`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch invoices');
  }
  
  return response.json();
};

export const createInvoice = async (invoice: any) => {
  const response = await fetch(`${API_URL}/invoices`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(invoice)
  });
  if (!response.ok) throw new Error('Failed to create invoice');
  return response.json();
};


export const getPaymentSheet = async (params: any) => {
  const url = new URL(`${API_URL}/excel`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.append(key, String(value));
    }
  });

  const response = await fetch(url.toString(), {
    method: "GET",
    headers: getAuthHeaders()
  });

  if (!response.ok) {
    throw new Error("Failed to fetch payment sheet");
  }

  const blob = await response.blob();

  const contentDisp = response.headers.get("Content-Disposition") || "";
  let filename = "";
  const fileNameMatch = /filename="?([^"]+)"?/.exec(contentDisp);
  if (fileNameMatch && fileNameMatch[1]) {
    filename = fileNameMatch[1];
  } else {
    const fmt = (d?: string) => (d ? d : "unknown");
    filename = `payment_sheet-${fmt(params.startDate)}_${fmt(
      params.endDate
    )}.xlsx`;
  }

  const link = document.createElement("a");
  const objectUrl = URL.createObjectURL(blob);
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
};

export const getPaymentSheetHistory = async () => {
  const response = await fetch(`${API_URL}/excel/getSheetHistory`, {
    method: "GET",
    headers: getAuthHeaders()
  }); 
  if (!response.ok) {
    throw new Error("Failed to fetch payment sheet history");
  }
  return response.json();
};
